import { FunctionComponent } from 'react';
import classnames from 'classnames';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';
import { CLASS_NAME_QUICK_VIEW_OPEN_BUTTON } from '../StaticTile/staticTileHelpers';
import { QUICK_VIEW_TYPE_STATIC, QUICK_VIEW_TYPE_DEFAULT, QuickViewType } from '../constants';

// Style
import styles from './styles.scss';

import QuickViewIcon from 'dibs-icons/exports/InfoCircle';

type QuickViewButtonProps = {
    openQuickView?: () => void;
    showQuickViewIcon?: boolean;
    hideDivider?: boolean;
    isSbTile?: boolean;
    /**
     * TODO: Replace isSbTile with this type argument
     */
    type?: QuickViewType;
};

const messages = defineMessages({
    label: {
        id: 'dibs-search-product-tile.QuickViewButton.label',
        defaultMessage: 'Show quick view information',
    },
});

export const QuickViewButton: FunctionComponent<QuickViewButtonProps> = ({
    openQuickView = () => {},
    showQuickViewIcon = true,
    hideDivider,
    isSbTile,
    type = QUICK_VIEW_TYPE_DEFAULT,
}) => {
    const intl = useIntl();
    if (!showQuickViewIcon) {
        return null;
    }
    return (
        <Link
            dataTn="quick-view-button"
            ariaLabel={intl.formatMessage(messages.label)}
            className={classnames(styles.link, {
                [CLASS_NAME_QUICK_VIEW_OPEN_BUTTON]: type === QUICK_VIEW_TYPE_STATIC,
                [styles.hideDivider]: hideDivider,
                [styles.isSbTile]: isSbTile,
            })}
            onClick={openQuickView}
        >
            <QuickViewIcon className={classnames({ [styles.isSbTile]: isSbTile })} />
        </Link>
    );
};
